import { roundups } from "@/mocks/communityData";
import SectionTitle from "./SectionTitle";

export default function Roundup() {
  return (
    <section id="roundup" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionTitle
          eyebrow="深度整理"
          title="大瓜合集 · 一瓜吃到底"
          desc="别只看热闹，来把瓜吃明白。编辑团队为你整理完整时间线、分辨真假截图，错过也不怕跟不上。"
        />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {roundups.map((r) => (
            <article
              key={r.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:shadow-soft"
            >
              <a href="#focus" className="relative block overflow-hidden">
                <div className="h-52 w-full overflow-hidden">
                  <img
                    src={r.image}
                    alt={`${r.title} 封面图`}
                    title={`${r.title} - 吃瓜聚集地`}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                </div>
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {r.tag}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                  <a href="#focus" className="transition hover:text-primary-600">
                    {r.title}
                  </a>
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{r.excerpt}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {r.time}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-heart-3-line text-accent-500" aria-hidden="true"></i>
                    {(r.likes / 1000).toFixed(1)}k 赞
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}